import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState,useEffect } from "react";
import editresultapi from '../api/editresult';
import loginapi from '../api/login';
import { AiOutlineDownload } from "react-icons/ai";
import { APISERVERURL } from '../APIServerURL';

function StudentTranscript({accessToken,setAccessToken,setRefreshFailed  }) {


const SemesterTranscript = ({ semesterTranscript }) => {
  if (!semesterTranscript || !semesterTranscript.courseList) {
    return <div>No transcript data available.</div>;
  }

  const { courseList, semester, semesterResult } = semesterTranscript;
  const {
    totalCredit,
    totalCreditEarned,
    totalHonourPoint,
    sgpa,
    result
  } = semesterResult || {};

  return (
    <div className="p-4 border rounded shadow-md width-full  text-xs">
      <h2 className="font-bold mb-4">Semester: {semester}</h2>

      <table className="w-full table-auto border-collapse">
        <thead>
          <tr className="bg-gray-200">
            <th className="border px-4 py-2">Code</th>
            <th className="border px-4 py-2">Title</th>
            <th className="border px-4 py-2">Grade</th>
            <th className="border px-4 py-2">Grade Point</th>
            <th className="border px-4 py-2">Credit</th>
            <th className="border px-4 py-2">Honour Point</th>
          </tr>
        </thead>
        <tbody>
          {courseList.map((course) => (
            <tr key={course._id}>
              <td className="border px-4 py-2">{course.course_code}</td>
              <td className="border px-4 py-2">{course.title}</td>
              <td className="border px-4 py-2">{course.grade}</td>
              <td className="border px-4 py-2">{course.gradepoint}</td>
              <td className="border px-4 py-2">{course.credit}</td>
              <td className="border px-4 py-2">{course.honur_point}</td>
            </tr>
          ))}

          {/* Summary Row */}
          <tr className="bg-yellow-100 font-semibold">
            <td className="border px-4 py-2 text-right" colSpan={2}>
              Total Credit: {totalCredit} | Earned: {totalCreditEarned}
            </td>
             <td className="border px-4 py-2 text-right" colSpan={2}>Total Point: {totalHonourPoint}</td>
            <td className="border px-4 py-2">SGPA: {sgpa}</td>
               <td className="border px-4 py-2">RESULT: {result}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};



const OverAllResultTable = ({ overAllResult }) => {
  if (!overAllResult) {
    return <div>No overall result available.</div>;
  }

  const {
    totalCredit,
    totalCreditEarned,
    totalHonourPoint,
    cgpa,
    result
  } = overAllResult;

  return (
    <div className="p-4 border rounded shadow-md width-full mt-6 text-xs">
      <h2 className=" font-bold mb-4 text-center">CUMULATIVE RECORD</h2>
      <table className="w-full table-auto border-collapse">
        <thead>
          <tr className="bg-gray-200">
            <th className="border px-4 py-2">Total Credit</th>
            <th className="border px-4 py-2">Credit Earned</th>
            <th className="border px-4 py-2">Honour Point</th>
            <th className="border px-4 py-2">CGPA</th>
            <th className="border px-4 py-2">Result</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border px-4 py-2 text-center">{totalCredit}</td>
            <td className="border px-4 py-2 text-center">{totalCreditEarned}</td>
            <td className="border px-4 py-2 text-center">{totalHonourPoint}</td>
            <td className="border px-4 py-2 text-center">{cgpa}</td>
            <td className={`border px-4 py-2 text-center font-bold ${result === 'PASS' ? 'text-green-600' : 'text-red-600'}`}>
              {result}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};



const StudentInfoCard = ({ student }) => {
  if (!student) {
    return <div>No student data available.</div>;
  }

  return (
    <div className="p-4 border rounded shadow-md w-full bg-white text-xs">
      <h2 className="font-bold mb-4">Student Information</h2>
      <table className="w-full table-auto">
        <tbody>
          <tr>
            <td className="font-semibold py-2">Roll No:</td>
            <td className="py-2">{student.rollno}</td>
          </tr>
          <tr>
            <td className="font-semibold py-2">Name:</td>
            <td className="py-2">{student.name}</td>
          </tr>
          <tr>
            <td className="font-semibold py-2">Programme Name:</td>
            <td className="py-2">{student.programme_name}</td>
          </tr>
          <tr>
            <td className="font-semibold py-2">Honours:</td>
            <td className="py-2">
              {student.MajorSub || student.honours_name}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};



const TranscriptDisplay = ({ transcript,downloadStudentTranscript,isDownloadingBG,isDownloadingNBG,isDownloadingTx }) => {
  if (!transcript) {
    return <div className="text-center text-white">No transcript provided.</div>;
  }

  return (
    <div className="w-full flex flex-col gap-6 px-4 py-4">
      
      <StudentInfoCard student={transcript.studentDetails} />

      {Array.isArray(transcript.semesterTranscript) && transcript.semesterTranscript.length > 0 ? (
        transcript.semesterTranscript.map((semTranscript, index) => (
          <SemesterTranscript key={index} semesterTranscript={semTranscript} />
        ))
      ) : (
        <p className="text-white text-center">No transcript data available.</p>
      )}

      <OverAllResultTable overAllResult={transcript.overAllResult} />

      <div className="w-full flex flex-col justify-center items-center">
        <p className="w-full text-center">RESULT DATE: {transcript.completionDate}</p>
        <p className="w-full text-center text-xs">(It's the student's most recent semester result date)</p>
      </div>

      <div className="w-full p-2 bg-blue-200 flex justify-center items-center gap-3">
    <button
  onClick={(e) => downloadStudentTranscript(transcript.studentDetails.rollno,'YES')}
  disabled={isDownloadingBG}
  className={`flex text-sm items-center gap-2 px-2 py-2 rounded-lg transition duration-200 ${
    isDownloadingBG
      ? 'bg-gray-400 cursor-not-allowed'
      : 'bg-orange-600 text-white hover:bg-orange-700'
  }`}
>
  {isDownloadingBG ? (
    <>
      <span className="text-white text-sm">Generating.....</span>
    </>
  ) : (
    <>
      <AiOutlineDownload size={20} />
     CONSOLIDATED GRADE CARD
    </>
  )}
</button>

<button
  onClick={(e) => downloadStudentTranscript(transcript.studentDetails.rollno,'YES',"transcript")}
  disabled={isDownloadingTx}
  className={`flex text-sm items-center gap-2 px-2 py-2 rounded-lg transition duration-200 ${
    isDownloadingTx
      ? 'bg-gray-400 cursor-not-allowed'
      : 'bg-orange-600 text-white hover:bg-orange-700'
  }`}
>
  {isDownloadingTx ? (
    <>
      <span className="text-white text-sm">Generating.....</span>
    </>
  ) : (
    <>
      <AiOutlineDownload size={20} />
      STUDENT TRANSCRIPT
    </>
  )}
</button>

<button
  onClick={(e) => downloadStudentTranscript(transcript.studentDetails.rollno,'NO')}
  disabled={isDownloadingNBG}
  className={`flex text-sm items-center gap-2 px-2 py-2 rounded-lg transition duration-200 ${
    isDownloadingNBG
      ? 'bg-gray-400 cursor-not-allowed'
      : 'bg-gray-600 text-white hover:bg-gray-700'
  }`}
>
  {isDownloadingNBG ? (
    <>
      <span className="text-white text-sm">Generating.....</span>
    </>
  ) : (
    <>
      <AiOutlineDownload size={20} />
     NO HEAD TRANSCRIPT
    </>
  )}
</button>

      </div>
    </div>
  );
};


  



  const navigate = useNavigate();
  const [rollno,setRollno]=useState('');

const [transcript,setTranscript]=useState(null);
const [errorMessage,setErrorMessage]=useState('');
const [isAppLoaded,setIsAppLoaded]=useState(true);
const [isDownloadingBG,setIsDownloadingBG]=useState(false);
const [isDownloadingNBG,setIsDownloadingNBG]=useState(false);
const [isDownloadingTx,setIsDownloadingTx]=useState(false);

  const handleGoBack = () => {
    navigate(`/`); 
  };



const handleRollnoChange = (e) => {
    setRollno(e.target.value);
    setErrorMessage('');
  };

    
    async function handleSearch(e)
        {
          e.preventDefault();
          setIsAppLoaded(false);
          try{
            const response= await editresultapi.post('/getStudentTranscript',{ rollno},{headers:{'Authorization':`Bearer ${accessToken}`}});    
             //alert(JSON.stringify(response.data));
             setTranscript(response.data.Transcript);
             if(!response.data.Transcript){setErrorMessage("No Records to Display!");}
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await editresultapi.post('/getStudentTranscript',{ rollno},{headers:{'Authorization':`Bearer ${nat}`}});    
                             setTranscript(response.data.Transcript);
                                if(!response.data.Transcript){setErrorMessage("No Records to Display!");}

               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
          finally
          {
             setIsAppLoaded(true);
          }
        }
  
   
   function downloadFile(fname)
   {
     fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
       response.blob().then((blob) => {         
           // Creating new object of PDF file
           const fileURL =
               window.URL.createObjectURL(blob);
                
           // Setting various property values
           let alink = document.createElement("a");
           alink.href = fileURL;
           alink.download = fname;
           alink.click();
           setIsAppLoaded(true);
       });
     });
   }
 
 const downloadStudentTranscript=async (rollno,bg,type="consolidated")=>{
 
   try{
     //alert(img+" "+postId);
     //post request to deletePhoto wit {id,fileName}
     if(bg==='YES')
      {
        if(type==="consolidated")
        {
          setIsDownloadingBG(true);
        }
        else{
              setIsDownloadingTx(true);
        }
        
      }
      else{
        setIsDownloadingNBG(true);
      }
     const response= await editresultapi.post('/downloadStudentTranscript',{rollno,bg,type},{headers:{'Authorization':`Bearer ${accessToken}`}});    
     alert(response.data);
     downloadFile(response.data);
   }
   catch(err)
   {
     if( err.response.status===403)
       {
         navigate(`/accessdenied`); 
       }
     try{
       const config = { withCredentials: true };
       const x=await loginapi.get('/getAccessToken',config);
       //alert(JSON.stringify(x['data']['accessToken']));
       
       const nat=x['data']['accessToken'];
       setAccessToken(nat);
       //console.log(`ne at ${nat}`);
       //console.log(`Second at:${accessToken}`);
       //alert('ok');
       try{       
         const response= await editresultapi.post('/downloadStudentTranscript',{rollno,bg,type},{headers:{'Authorization':`Bearer ${nat}`}});    
         alert(JSON.stringify(response.data));
         downloadFile(response.data);
        }
        catch(err)
        {
         if( err.response.status===403)
           {
             navigate(`/accessdenied`); 
           }
         alert('unusual error newposts.js');
         setIsAppLoaded(true);
         //alert(JSON.stringify(err));
         //navigate('/');
        }
     }
     catch(err)
     {
       alert(JSON.stringify(err));
       setIsAppLoaded(true);
       //setError(JSON.stringify(err));
       //navigate('/');
     }
 
   }
   finally{
        if(bg==='YES')
      {
        if(type==="consolidated")
        {
          setIsDownloadingBG(false);
        }
        else{
              setIsDownloadingTx(false);
        }
        
      }
      else{
        setIsDownloadingNBG(false);
      }
   }
 }

  return (
     <main className="w-full">
         <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center"> STUDENT TRANSCRIPT</h1>
            <p className="w-full text-center font-semibold text-xs text-transparent">(The form is autosave)</p>    
          </div>

    

      <div className="flex flex-col justify-center gap-4 mt-4">
         <div className="w-full flex items-center justify-center mt-4 ">
                <div
                  className="text-center w-full max-w-[600px]  grid grid-cols-[1fr_3fr_1fr] gap-2 p-1 text-sm align-items-end "
                >
                <label className="px-2 py-2">ROLLNO:</label>

                <input
                                type="text" 
                                name="txtRollno"
                                value={rollno}
                                onChange={handleRollnoChange}
                              className="w-full p-2 mt-1 bg-transparent border-b border-gray-400 focus:border-green-500 focus:border-b outline-none transition-all"
                              />
              <button className="bg-green-500 text-white font-semibold px-6 py-2 rounded-full shadow-md transition-all duration-300 hover:bg-green-600 hover:scale-105 active:scale-95"
              onClick={handleSearch}>
                SEARCH
              </button>

                </div>
        </div>


{transcript && (
  <TranscriptDisplay  transcript={transcript} downloadStudentTranscript={downloadStudentTranscript} isDownloadingBG={isDownloadingBG} isDownloadingNBG={isDownloadingNBG} isDownloadingTx={isDownloadingTx}></TranscriptDisplay>
)}
{isAppLoaded && errorMessage.length>0 && <p className="w-full text-center">{errorMessage}</p>}
{!isAppLoaded && <p className="w-full text-center">Please wait...</p>}

      </div>
      </div>
    </main>
  );
}

export default StudentTranscript;
